import { COPY_STRINGS } from "../../../../constants/translatedCopy";
import { PROGRESS_STATES, SPEECH_VOLUME_CHECK_STATES } from "../StudentVolumeChecksConstants";
import { amiraGestures } from '../../../Coach/GesturedSpeech'
import { delay } from "../../../../services/util";
const spotBark = require('../../../../../assets/sounds/dances/SFX_cartoon-happy-puppy-bark_v2.mp3')

export default async function handleStudentModeSpeech({ speakWith, speechProps, currentProgressState, settings, goToNextState, setCurrentSpeechVolumeCheckState, acceptedAtKindOfLoudVolume, toggleReaderContainer, showMicIcon, teacherCalled, setCurrentProgressState, spotHook }) {

    if(teacherCalled.current && currentProgressState === PROGRESS_STATES.INITIAL){
        setCurrentProgressState(PROGRESS_STATES.SPOT_ON_SCREEN_2)
        return
    }

    if (currentProgressState === PROGRESS_STATES.INITIAL) {
        await speakWith({
            doBeforeSpeak: {
                "forFTUE": async () => {
                    if (settings.shouldSkipFTUEIntro) {
                        speechProps.playDance({
                            gesture: amiraGestures.Wave
                        });
                        await speechProps.speakWithPromise({
                            textToSpeak: COPY_STRINGS.student_checks.welcome_back
                        })
                    }
                    speechProps.abortSpeech();
                    speechProps.playDance({
                        gesture: amiraGestures.TheRenegadeDance_short
                    })
                    await spotHook.playDiscoBall()
                }
            },
            speak: {
                "forFTUE": COPY_STRINGS.student_checks.microphone_access_granted,
            },
        })

        spotHook.disappear()

        await speakWith({
            doBeforeSpeak: {
                "forFTUE": async () => {
                    speechProps.abortSpeech();
                    speechProps.playDance({
                        gesture: amiraGestures.SlowClap
                    })
                }
            },
            speak: {
                "forFTUE": COPY_STRINGS.student_checks.intro_amira_moveon_one,
            },
            doAfterSpeak: {
                "forFTUE": async () => {
                    await speechProps.speakWithPromise({ textToSpeak: COPY_STRINGS.student_checks.intro_amira_moveon_two })
                    await speechProps.speakWithPromise({ textToSpeak: COPY_STRINGS.student_checks.intro_amira_moveon_three })
                    await speechProps.playDance({ gesture: amiraGestures.TapOnWatch })
                }
            }
        })

        goToNextState()
    }
    if (currentProgressState === PROGRESS_STATES.INTRODUCTION_SCREEN_1) {

        const introduceScreen = () => {
            speechProps.abortSpeech();
            speechProps.playDance({
                gesture: amiraGestures.FingersSweepDown
            })
            toggleReaderContainer();
        }

        await speakWith({
            doBeforeSpeak: {
                "forFTUE": introduceScreen,
                "forReturningUserWithAssessment": introduceScreen,
                "forReturningUser": introduceScreen
            },
            speak: {
                "forFTUE": COPY_STRINGS.student_checks.intro_screen,
                "forReturningUserWithAssessment": COPY_STRINGS.student_checks.return_user_wake_up_prompt,
            },
        })

        goToNextState()
    }
    if (currentProgressState === PROGRESS_STATES.INTRODUCTION_SCREEN_2) {

        await speakWith({
            doBeforeSpeak: {
                "forFTUE": () => {
                    spotHook.playMultipleBooks()
                    speechProps.abortSpeech();
                    speechProps.playDance({
                        gesture: amiraGestures.Glance_Beginning
                    })
                }
            },
            speak: {
                "forFTUE": COPY_STRINGS.student_checks.volume_check_intro_one
            },
        })

        speechProps.playDance({
            gesture: amiraGestures.Glance_End
        })

        spotHook.disappear()

        await speakWith({
            speak: {
                "forFTUE": COPY_STRINGS.student_checks.volume_check_intro_two
            },
            doAfterSpeak: {
                "forFTUE": async () => {
                    spotHook.playSingleBook()
                }
            }
        })

        goToNextState()
    }
    if (currentProgressState === PROGRESS_STATES.SPOT_TRANSITION_ON_SCREEN) {

        await speakWith({
            doBeforeSpeak: {
                "forFTUE": () => {
                    speechProps.playDance({
                        gesture: amiraGestures.PointingWithChalk
                    })
                }
            },
            speak: {
                "forFTUE": COPY_STRINGS.student_checks.check_on_spot_intro
            },
            doAfterSpeak: {
                "forFTUE": async () => {
                    await speechProps.speakWithPromise({ textToSpeak: COPY_STRINGS.student_checks.check_on_spot_intro_part_two })
                }
            }
        })

        goToNextState()
    }
    if (currentProgressState === PROGRESS_STATES.SPOT_ON_SCREEN) {

        await speakWith({
            doBeforeSpeak: {
                "forFTUE": async () => {
                    spotHook.goSleep()
                    speechProps.playDance({
                        gesture: amiraGestures.WideEyes_nomouth
                    })
                },
                "forReturningUserWithAssessment": async () => {
                    spotHook.goSleep()
                }
            },
            speak: {
                "forFTUE": COPY_STRINGS.student_checks.oh_hes_sleeping
            },
        })

        await speakWith({
            speak: {
                "forFTUE": COPY_STRINGS.student_checks.lets_wake_him_up_one,
                "forReturningUserWithAssessment": COPY_STRINGS.student_checks.return_user_talk_loud_enough,
            },
        })

        await speakWith({
            speak: {
                "forFTUE": COPY_STRINGS.student_checks.lets_wake_him_up_two,
            }
        })

        speechProps.playDance({
            gesture: amiraGestures.PointingWithChalk
        })

        showMicIcon();
        await speechProps.speakWithPromise({ textToSpeak: COPY_STRINGS.student_checks.lets_wake_him_up_three })
        
        goToNextState()
    }
    if (currentProgressState === PROGRESS_STATES.SPOT_ON_SCREEN_2) {
        if(teacherCalled.current){
            spotHook.goSleep()
        }
        await speechProps.speakWithPromise({ textToSpeak: COPY_STRINGS.student_checks.wake_up_spot })
        setCurrentSpeechVolumeCheckState(SPEECH_VOLUME_CHECK_STATES.WAITING_FOR_INITIAL_SPEECH)
    }
    if (currentProgressState === PROGRESS_STATES.SPOT_WOKE_UP) {
        await spotHook.wakeUpFromSleep()

        if (acceptedAtKindOfLoudVolume) {
            speechProps.playDance({
                gesture: amiraGestures.ThumbsUp
            })
            await speechProps.speakWithPromise({ textToSpeak: COPY_STRINGS.student_checks.he_heard_you_loud })
        } else {
            speechProps.playDance({
                gesture: amiraGestures.Excited_nomouth
            })
            await speechProps.speakWithPromise({ textToSpeak: COPY_STRINGS.student_checks.he_heard_you })
        }

        speechProps.playDance({
            gesture: amiraGestures.Wave
        })

        await speechProps.speakWithPromise({ textToSpeak: COPY_STRINGS.student_checks.he_heard_you_two })
        await spotHook.bark()
        await delay(1500);
        goToNextState()
    }
}
